module.exports = __webpack_public_path__ + "static/media/ccard-amex.8f69e68a.svg";